import Utils from '../Services/Utils';
import Attachments from '../Services/api/Attachments';

class WorkOrderModel {
  constructor(item = {}) {
    this.account = item.account || null;
    this.groupId = item.groupId || null;
    this.triggerId = item.triggerId || null;
    this.formDataId = item.formDataId || null;
    this.floor = item.floor || null;
    this.unit = item.unit || null;
    this.requestedBy = item.requestedBy || null;
    this.service = item.service || Utils.formatDate(new Date());
    this.phone = item.phone || null;
    this.notes = item.notes || null;
    this.email = item.email || null;
    this.has_permission_to_enter = item.has_permission_to_enter || false;
    this.brief_description = item.brief_description || null;
    this.due_date = item.due_date || null;
    this.realStart = item.realStart || null;
    this.realFinish = item.realFinish || null;
    this.full_description = item.full_description || null;
    this.problemDescription = item.problemDescription || null;
    this.assignTo = item.assignTo || [];
    this.property = item.property;
    this.time = moment(new Date()).format();
    this.label = item.label || null;
    this.id = item.id || null;
    this.attachments = item.attachments || [];
    this.pms_extra_fields = item.pms_extra_fields || {};
    this.tenant_caused = item.tenant_caused || false;
    this.technician_notes = item.technician_notes || null;
    this.tenant_code = item.tenant_code || null;
  }

  static parse = async (item) => {
    let users = item.account_users_assigned || [];
    if (users.length > 0) {
      users = users.map((valueitem) => (!Utils.isNull(valueitem.id) ? valueitem.id : valueitem));
    }
    const pms_extra_fields = {};
    Object.keys(item.pms_extra_fields).forEach((key) => {
      pms_extra_fields[key] = Utils.isObject(item.pms_extra_fields[key]) ? item.pms_extra_fields[key].id : item.pms_extra_fields[key];
      return pms_extra_fields;
    });
    return new WorkOrderModel({
      id: item.id || null,
      account: item.account || null,
      property: item.property || null,
      groupId: item.field_group_id || null,
      triggerId: item.field_trigger_id || null,
      floor: item.floor_code || null,
      unit: item.unit || null,
      requestedBy: item.requester_name || null,
      service: item.service_request_date || null,
      phone: item.requester_phone_number || null,
      notes: item.access_notes || null,
      email: item.requester_email || null,
      has_permission_to_enter: item.has_permission_to_enter || false,
      brief_description: item.brief_description || null,
      due_date: item.due_date || null,
      realStart: item.real_start || null,
      realFinish: item.real_finish || null,
      attachments: item.attachments || [],
      full_description: item.full_description || null,
      problemDescription: item.problem_description_notes || null,
      assignTo: users || [],
      user: item.user,
      pms_extra_fields: pms_extra_fields,
      tenant_caused: item.tenant_caused || false,
      technician_notes: item.technician_notes || null,
      tenant_code: item.tenant_code || null
    });
  };

  serialize = async (item) => {
    let users = item.assignTo || [];
    if (users.length > 0) {
      users = users.map((valueitem) => (!Utils.isNull(valueitem.value) ? valueitem.value : valueitem));
    }
    const attachments = item.attachments || [];
    const files = [];
    if (attachments.length > 0) {
      const promises = attachments.map(async (valueitem) => {
        if (valueitem.file) {
          const file = await Attachments.create([valueitem]);
          files.push(file.id);
        } else {
          files.push(valueitem.id || valueitem);
        }
        return null;
      });
      await Promise.all(promises);
    }
    const pms_extra_fields = {};
    Object.keys(item.pms_extra_fields).forEach((key) => {
      pms_extra_fields[key] = Utils.isObject(item.pms_extra_fields[key]) ? item.pms_extra_fields[key].value : item.pms_extra_fields[key];
      return pms_extra_fields;
    });
    const unit = Utils.isObject(item.unit) ? item.unit.value : item.unit;
    return {
      id: item.id || undefined,
      account: item.account || undefined,
      floor_code: item.floor || null,
      unit: unit || null,
      requester_name: item.requestedBy || null,
      service_request_date: item.service || null,
      requester_phone_number: item.phone || null,
      access_notes: item.notes || null,
      requester_email: item.email || null,
      has_permission_to_enter: item.has_permission_to_enter || false,
      brief_description: item.brief_description || null,
      problem_description_notes: item.problemDescription || null,
      due_date: item.due_date || null,
      real_start: item.realStart || null,
      real_finish: item.realFinish || null,
      account_users_assigned: users,
      attachments: files,
      property: item.property || null,
      full_description: item.full_description || null,
      pms_extra_fields: pms_extra_fields,
      tenant_caused: item.tenant_caused || false,
      technician_notes: item.technician_notes || null,
      user_time: (moment().format('MM/DD/YYYY') +', '+ new Date().toLocaleTimeString([], {hour12: true}) +' '+ moment.tz(jstz.determine().name()).zoneAbbr()),
      tenant_code: item.tenant_code || null
    };
  };
}

export default WorkOrderModel;
